<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g id="icon">
        <path d="M10.7498 10.2832L9 5.25L7.2532 10.2832H10.7498Z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.5 0C2.01471 0 0 2.01471 0 4.5V13.5C0 15.9853 2.01471 18 4.5 18H13.5C15.9853 18 18 15.9853 18 13.5V4.5C18 2.01471 15.9853 0 13.5 0H4.5ZM3 15H5.71875L6.60892 12.2637H11.3928L12.2812 15H15L10.8633 3H7.14258L3 15Z"
        />
      </g>
    </g>
  </svg>
</template>
